import { createColorClasses } from "@/theme/colors";
import { IconProps } from "@/types/icons";
import clsx from "clsx";

export const Position = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  fillColor = "#0066CC",
  onClick,
  decorative = false,
  ariaLabel = "Position",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes)}
      width={width}
      height={height}
      onClick={onClick}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill={fillColor}
      />
    </svg>
  );
};
